var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M24.3 12.574a1.97 1.97 0 012.78 0l8.346 8.355c.765.77.765 2.015 0 2.785l-9.555 9.566c-.49.49-1.206.694-1.865.814l-9.02 1.88c-1.62.25-3.226-1.36-2.956-2.96l1.905-9.01c.12-.71.355-1.41.845-1.9zm-.946 4.511L16.48 23.96l-.88 4.615 3.825 3.825 4.615-.884 6.875-6.87a.974.974 0 000-1.377.979.979 0 00-1.374 0l-6.36 6.357a1.213 1.213 0 11-1.714-1.718l6.354-6.356a.966.966 0 000-1.372.97.97 0 00-1.374 0l-6.36 6.356a1.212 1.212 0 01-1.715 0 1.216 1.216 0 010-1.717l6.355-6.357a.973.973 0 00-1.373-1.377z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
